"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "fontFamily", {
  enumerable: true,
  get: function get() {
    return _typography.fontFamily;
  }
});
Object.defineProperty(exports, "Text", {
  enumerable: true,
  get: function get() {
    return _typography.Text;
  }
});
Object.defineProperty(exports, "themedFontFamily", {
  enumerable: true,
  get: function get() {
    return _typography.themedFontFamily;
  }
});
Object.defineProperty(exports, "injectFontFiles", {
  enumerable: true,
  get: function get() {
    return _typography.injectFontFiles;
  }
});
Object.defineProperty(exports, "getThemeTextStyleValues", {
  enumerable: true,
  get: function get() {
    return _typography.getThemeTextStyleValues;
  }
});
Object.defineProperty(exports, "getResolvedWeightWithTheme", {
  enumerable: true,
  get: function get() {
    return _typography.getResolvedWeightWithTheme;
  }
});
Object.defineProperty(exports, "BorderRadius", {
  enumerable: true,
  get: function get() {
    return _theming.BorderRadius;
  }
});
Object.defineProperty(exports, "BorderRadiusSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.BorderRadiusSemantics;
  }
});
Object.defineProperty(exports, "BorderRadiusTokens", {
  enumerable: true,
  get: function get() {
    return _theming.BorderRadiusTokens;
  }
});
Object.defineProperty(exports, "BorderWidth", {
  enumerable: true,
  get: function get() {
    return _theming.BorderWidth;
  }
});
Object.defineProperty(exports, "BorderWidthSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.BorderWidthSemantics;
  }
});
Object.defineProperty(exports, "BorderWidthTokens", {
  enumerable: true,
  get: function get() {
    return _theming.BorderWidthTokens;
  }
});
Object.defineProperty(exports, "CaviarColors", {
  enumerable: true,
  get: function get() {
    return _theming.CaviarColors;
  }
});
Object.defineProperty(exports, "Colors", {
  enumerable: true,
  get: function get() {
    return _theming.Colors;
  }
});
Object.defineProperty(exports, "ColorsSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.ColorsSemantics;
  }
});
Object.defineProperty(exports, "ColorsTokens", {
  enumerable: true,
  get: function get() {
    return _theming.ColorsTokens;
  }
});
Object.defineProperty(exports, "Shape", {
  enumerable: true,
  get: function get() {
    return _theming.Shape;
  }
});
Object.defineProperty(exports, "ShapeSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.ShapeSemantics;
  }
});
Object.defineProperty(exports, "ShapeTokens", {
  enumerable: true,
  get: function get() {
    return _theming.ShapeTokens;
  }
});
Object.defineProperty(exports, "Size", {
  enumerable: true,
  get: function get() {
    return _theming.Size;
  }
});
Object.defineProperty(exports, "SizeSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.SizeSemantics;
  }
});
Object.defineProperty(exports, "SizeTokens", {
  enumerable: true,
  get: function get() {
    return _theming.SizeTokens;
  }
});
Object.defineProperty(exports, "Spacing", {
  enumerable: true,
  get: function get() {
    return _theming.Spacing;
  }
});
Object.defineProperty(exports, "SpacingSemantics", {
  enumerable: true,
  get: function get() {
    return _theming.SpacingSemantics;
  }
});
Object.defineProperty(exports, "SpacingTokens", {
  enumerable: true,
  get: function get() {
    return _theming.SpacingTokens;
  }
});
Object.defineProperty(exports, "Themes", {
  enumerable: true,
  get: function get() {
    return _theming.Themes;
  }
});
Object.defineProperty(exports, "ThemingContext", {
  enumerable: true,
  get: function get() {
    return _theming.ThemingContext;
  }
});
Object.defineProperty(exports, "Theming", {
  enumerable: true,
  get: function get() {
    return _theming.Theming;
  }
});
Object.defineProperty(exports, "ThemingConsumer", {
  enumerable: true,
  get: function get() {
    return _theming.ThemingConsumer;
  }
});
Object.defineProperty(exports, "TypographyDensities", {
  enumerable: true,
  get: function get() {
    return _theming.TypographyDensities;
  }
});
Object.defineProperty(exports, "withTheming", {
  enumerable: true,
  get: function get() {
    return _theming.withTheming;
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _icons.Icon;
  }
});
Object.defineProperty(exports, "Shadows", {
  enumerable: true,
  get: function get() {
    return _shadows["default"];
  }
});
Object.defineProperty(exports, "Stack", {
  enumerable: true,
  get: function get() {
    return _spacing.Stack;
  }
});
Object.defineProperty(exports, "StackChildren", {
  enumerable: true,
  get: function get() {
    return _spacing.StackChildren;
  }
});
Object.defineProperty(exports, "Inset", {
  enumerable: true,
  get: function get() {
    return _spacing.Inset;
  }
});
Object.defineProperty(exports, "Inline", {
  enumerable: true,
  get: function get() {
    return _spacing.Inline;
  }
});
Object.defineProperty(exports, "InlineChildren", {
  enumerable: true,
  get: function get() {
    return _spacing.InlineChildren;
  }
});
Object.defineProperty(exports, "Media", {
  enumerable: true,
  get: function get() {
    return _mediaQueries.Media;
  }
});
Object.defineProperty(exports, "Breakpoints", {
  enumerable: true,
  get: function get() {
    return _mediaQueries.Breakpoints;
  }
});
Object.defineProperty(exports, "getFocusStyles", {
  enumerable: true,
  get: function get() {
    return _focus["default"];
  }
});
Object.defineProperty(exports, "encodeIconSVG", {
  enumerable: true,
  get: function get() {
    return _utils.encodeIconSVG;
  }
});
Object.defineProperty(exports, "WorldCountryCodes", {
  enumerable: true,
  get: function get() {
    return _i18n.WorldCountryCodes;
  }
});
Object.defineProperty(exports, "CountryCodeToCountryNames", {
  enumerable: true,
  get: function get() {
    return _i18n.CountryCodeToCountryNames;
  }
});

var _typography = require("./typography");

var _styledComponents = require("styled-components");

var _theming = require("./theming");

var _icons = require("./icons");

var _shadows = _interopRequireDefault(require("./shadows"));

var _spacing = require("./spacing");

var _mediaQueries = require("./mediaQueries");

var _focus = _interopRequireDefault(require("./focus"));

var _utils = require("./icons/utils");

var _i18n = require("./i18n");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

(0, _typography.injectFontFiles)();
(0, _styledComponents.injectGlobal)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  *,\n  *:after,\n  *:before {\n    box-sizing: border-box;\n  }\n\n  body {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-variant-ligatures: no-common-ligatures;\n    margin: 0;\n    padding: 0;\n  }\n"])));